import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ isLoggedIn, userRole, handleLogout }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setIsScrolled(isScrolled);
    };

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`bg-gray-900 ${isScrolled ? 'bg-opacity-75' : 'bg-opacity-35'} p-3 fixed w-full z-10`}>
      <div className="flex justify-between items-center">
        {/* Logo or Home Link */}
        <Link to="/" className=" text-white text-lg font-bold">
          Home
        </Link>

        {/* Hamburger Icon for Mobile */}
        <button
          className="sm:hidden text-white text-xl focus:outline-none"
          onClick={toggleMenu}
        >
          ☰
        </button>

        {/* Links for larger screens */}
        <div className="hidden sm:flex space-x-8 items-center">
          <Link to="/batch-details" className="text-white text-lg font-bold">
            Batch Details
          </Link>

          <Link to="/game" className="text-white text-lg font-bold">
            Game
          </Link>

          <Link to="/leaderboards" className="text-white text-lg font-bold">
            Leaderboard
          </Link>

          {/* Render navigation links based on authentication and role */}
          {isLoggedIn && (
            <>
              {userRole === 'admin' && (
                <Link to="/admin" className="text-white text-lg font-bold">
                  Admin
                </Link>
              )}
              {userRole !== 'admin' && (
                <Link to={`/${userRole}`} className="text-white text-lg font-bold">
                  {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
                </Link>
              )}
            </>
          )}
        </div>

        {/* Logout and Login Links for larger screens */}
        <div className="hidden sm:flex">
          {isLoggedIn ? (
            <Link to="/" onClick={handleLogout} className="text-white text-lg font-bold">
              Logout
            </Link>
          ) : (
            <Link to="/login" className="text-white text-lg font-bold">
              Login
            </Link>
          )}
        </div>
      </div>

      {/* Mobile Menu - Visible when the menu button is clicked */}
      {isMenuOpen && (
        <div className="sm:hidden flex flex-col mt-3 space-y-2">
          <Link to="/batch-details" className="text-white text-lg font-bold" onClick={toggleMenu}>
            Batch Details
          </Link>
          <Link to="/game" className="text-white text-lg font-bold" onClick={toggleMenu}>
            Game
          </Link>
          <Link to="/leaderboards" className="text-white text-lg font-bold" onClick={toggleMenu}>
            Leaderboard
          </Link>

          {/* Render navigation links based on authentication and role */}
          {isLoggedIn && (
            <>
              {userRole === 'admin' && (
                <Link to="/admin" className="text-white text-lg font-bold" onClick={toggleMenu}>
                  Admin
                </Link>
              )}
              {userRole !== 'admin' && (
                <Link to={`/${userRole}`} className="text-white text-lg font-bold" onClick={toggleMenu}>
                  {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
                </Link>
              )}
            </>
          )}

          {/* Logout and Login Links */}
          {isLoggedIn ? (
            <Link to="/" onClick={() => { handleLogout(); toggleMenu(); }} className="text-white text-lg font-bold">
              Logout
            </Link>
          ) : (
            <Link to="/login" className="text-white text-lg font-bold" onClick={toggleMenu}>
              Login
            </Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
